import { Box, Card, CardContent, Typography } from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import { UpcomingItem } from "../types";
import { PlaceholderBadge } from "./PlaceholderBadge";
import { EmptyState } from "./EmptyState";
import { cardTitleSx, dashboardCardSx } from "../responsiveText";

type UpcomingEventsCardProps = {
  items: UpcomingItem[];
};

export const UpcomingEventsCard = ({ items }: UpcomingEventsCardProps) => {
  return (
    <Card elevation={0} sx={dashboardCardSx}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="subtitle1" fontWeight={600} sx={cardTitleSx}>
              Upcoming
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Events &amp; announcements
            </Typography>
          </Box>
          <PlaceholderBadge />
        </Box>

        {items.length === 0 ? (
          <EmptyState message="No upcoming events" height={200} />
        ) : (
        <Box sx={{ mt: 1 }}>
          {items.map((item) => (
            <Box key={item.id} sx={{ display: "flex", gap: 1.5, py: 1.25 }}>
              {item.kind === "event" ? (
                <Box
                  sx={{
                    width: 46,
                    height: 46,
                    borderRadius: 1.5,
                    backgroundColor: "grey.100",
                    border: "1px solid #eceff2",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Typography variant="body2" fontWeight={700} color="primary" sx={{ lineHeight: 1 }}>
                    {item.day}
                  </Typography>
                  <Typography variant="caption" sx={{ fontSize: 9, fontWeight: 600, color: "text.secondary" }}>
                    {item.month}
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    width: 46,
                    height: 46,
                    borderRadius: 1.5,
                    backgroundColor: "warning.light",
                    color: "warning.dark",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <CampaignIcon fontSize="small" />
                </Box>
              )}
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  {item.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.detail}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
        )}
      </CardContent>
    </Card>
  );
};
